module.exports = __webpack_public_path__ + "img/Pista_0927.b9e8385e.png";